import { OPC, TIPOS, fmtEur } from "@/lib/api";
import { SelectField, Section } from "@/components/Fields";

export const EconomicoPanel = ({ f, set, treatments }) => {
  const pagado = treatments.reduce((s, t) => s + (t.pagado || 0), 0);
  const pendiente = treatments.reduce((s, t) => s + (t.pendiente_pago || 0), 0);
  return (
    <Section title="Económico (solo administración)" testId="sec-economico">
      <SelectField label="Estado económico" value={f.economico} onChange={set("economico")} options={OPC.economico} testId="pf-economico" />
      <div className="grid grid-cols-2 gap-3 mt-3">
        <div><div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Pagado</div><div className="font-[JetBrains_Mono] text-lg text-emerald-700" data-testid="eco-pagado">{fmtEur(pagado)}</div></div>
        <div><div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Pendiente</div><div className="font-[JetBrains_Mono] text-lg text-amber-700" data-testid="eco-pendiente">{fmtEur(pendiente)}</div></div>
      </div>
      <div className="mt-3 divide-y divide-slate-100 text-xs">
        {treatments.map((t) => (
          <div key={t.id} className="flex justify-between py-1.5"><span>{TIPOS[t.tipo]?.single}{t.bono_num ? ` nº ${t.bono_num}` : ""}</span><span className="font-[JetBrains_Mono]">{fmtEur(t.pagado)} · pend. {fmtEur(t.pendiente_pago)}</span></div>
        ))}
      </div>
    </Section>
  );
};
